jQuery(document).ready(function ($) {
  if($('.testimonials-list').length) {
    $('.testimonials-list').slick({
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 3,
      autoplay: true,
      autoplaySpeed: 3000,
      prevArrow: '<button type="button" class="slick-arrow slick-prev"><i class="fa fa-angle-left"></i></button>',
      nextArrow: '<button type="button" class="slick-arrow slick-next"><i class="fa fa-angle-right"></i></button>',
      responsive: [
        {
          breakpoint: 940,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        }
      ]
    });
  }

  if($('.about-slider-wrap').length) {
    $('.about-slider-wrap').slick({
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3000,
      appendArrows: $('.about-slider-navigation'),
      prevArrow: '<button type="button" class="slick-arrow slick-prev"><i class="cd-icon cd-icon-arrow-left"></i></button>',
      nextArrow: '<button type="button" class="slick-arrow slick-next"><i class="cd-icon cd-icon-arrow-right"></i></button>',
      responsive: [
        {
          breakpoint: 940,
          adaptiveHeight: true,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        }
      ]
    });
  }
  
  if($('.cd-sidebar-signup').length) {
    $('.cd-sidebar-signup').closest('.widget').addClass('cd-widget-signup');

    $formHeader = $('.mcsc-signup-form-header').detach();
    $formHeader.prependTo('.mcsc-signup-image-box');
  }

  $("a[href^=#]").on("click", function(e){
    $anchor = $(this).attr('href');

    if($anchor.length) {
      e.preventDefault();
      $diff = 50;

      $("body, html").animate({
        scrollTop: $($anchor).offset().top - $diff
      }, 300);
    }
  });

  if(window.innerWidth < 1024) {
    console.log($('.slicknav_menutxt').length);
    while($('.slicknav_menutxt').length < 1) {
      console.log("Inactive");
    }
  }
});